<!-- svg 电站概览电流功率 -->
<template>
  <div class="svg" />
</template>

<script>
const { SVG, Runner, Timeline } = require('@svgdotjs/svg.js')
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default () {
        return {
          nPower: 0,
          fPower: 0,
          pPower: 0,
          bSoc: 0,
          capacity: 1
        }
      }
    }
  },
  data () {
    return {
      battery_75: require('@/assets/svg/battery_75.svg'),
      info_filled: require('@/assets/svg/info_filled.svg'),
      inverter: require('@/assets/svg/inverter.svg'),
      pv: require('@/assets/svg/pv.svg'),
      consumption: require('@/assets/svg/consumption.svg'),
      grid: require('@/assets/svg/grid.svg'),
      svg: null
    }
  },
  watch: {
    data: {
      deep: true,
      handler () {
        this.$_resizeHandler()
      }
    }
  },
  beforeMount () {
    window.addEventListener('resize', this.$_resizeHandler)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.$_resizeHandler)
  },
  created () {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    $_resizeHandler () {
      this.$el.innerHTML = ''
      this.init()
    },
    init () {
      // console.log(this.data)
      this.svg = SVG().addTo('.svg')
      this.svg.size(this.$el.clientWidth, 300)
      // 发电动画
      if (this.data.pPower > 0) {
        this.drawCircle(this.svg, this.$el.clientWidth, 300, -120, -80, 'rgb(247, 192, 2)', true)
      }
      // 负载动画
      if (this.data.fPower > 0) {
        this.drawCircle(this.svg, this.$el.clientWidth, 300, 120, -80, 'rgb(112, 175, 205)', false)
      }
      // 电网动画
      if (this.data.nPower > 0) {
        this.drawCircle(this.svg, this.$el.clientWidth, 300, -120, 80, '#ccc', false)
      } else if (this.data.nPower < 0) {
        this.drawCircle(this.svg, this.$el.clientWidth, 300, -120, 80, '#ccc', true)
      }
      // 电池动画
      if (this.data.bi > 0) {
        this.drawCircle(this.svg, this.$el.clientWidth, 300, 120, 80, 'rgb(108, 190, 88)', false)
      } else if (this.data.bi < 0) {
        this.drawCircle(this.svg, this.$el.clientWidth, 300, 120, 80, 'rgb(108, 190, 88)', true)
      }
      // 发电
      this.drawSvg(this.svg, this.$el.clientWidth, 300, 55, 40, -120, -80, 'rgb(252, 231, 152)', 'rgb(247, 192, 2)', this.pv, this.data.pPower + ' W', this.data.pPower / (this.data.capacity * 10))
      // 电池
      this.drawSvg(this.svg, this.$el.clientWidth, 300, 55, 40, 120, 80, 'rgb(183, 223, 171)', 'rgb(108, 190, 88)', this.battery_75, (this.data.bSoc || 0) + ' %', this.data.bSoc)

      // 负载
      this.drawSvg(this.svg, this.$el.clientWidth, 300, 55, 40, 120, -80, 'rgb(198, 223, 235)', 'rgb(112, 175, 205)', this.consumption, this.data.fPower + ' W', this.data.fPower / (this.data.capacity * 10))
      // 电网
      this.drawSvg3(this.svg, this.$el.clientWidth, 300, 55, 40, -120, 80, '#ccc', '#fff', this.grid, Math.abs(this.data.nPower) + ' W')
      // 逆变器
      this.drawSvg2(this.svg, this.$el.clientWidth, 300, 55, 40, 0, 0, '#ccc', this.inverter)
    },
    drawSvg (draw, sizeX, sizeY, r1, r2, tX, tY, fill, fill2, imageUrl, value, num) {
      var group = draw.group()
      var wCircle = draw.circle(2 * r1).attr({ cx: sizeX / 2, cy: sizeY / 2, fill: '#fff', stroke: fill, 'stroke-width': 1 })
      var nCircle = draw.circle(2 * r2).attr({ cx: sizeX / 2, cy: sizeY / 2, fill: '#fff', stroke: fill, 'stroke-width': 1 })
      var image = draw.image(imageUrl).attr({ x: sizeX / 2 - 25, y: sizeY / 2 - 25, width: 50, height: 50 })
      var group_g = draw.group()
      group_g.transform({ translateX: sizeX / 2, translateY: sizeY / 2 })
      group.add(wCircle)
      group.add(nCircle)
      group.add(image)
      group.add(group_g)
      var p1 = `M 0 -${r2 + 1} L 0 -${r1 - 1} A ${r1 - 1} ${r1 - 1} 0 1 1 -${r1 - 1} 0
        L -${r2 + 1} 0 A ${r2 + 1} ${r2 + 1} 0 1 0 0 -${r2 + 1}Z`
      var path = draw.path(p1).attr({ fill: fill, stroke: '#fff', 'stroke-width': 1 })
      // ---------------
      var d1, d2
      d1 = (270 * num / 100) >= 180 ? 1 : 0
      d2 = (270 * num / 100) >= 180 ? 1 : 0
      var p3 = `M 0 -${r2 + 1} L 0 -${r1 - 1} A ${r1 - 1} ${r1 - 1} 0 ${d1} 1 ${(r1 - 1) * Math.cos((-90 + 270 * num / 100) / 180 * Math.PI)} ${(r1 - 1) * Math.sin((-90 + 270 * num / 100) / 180 * Math.PI)}
        L ${(r2 + 1) * Math.cos((-90 + 270 * num / 100) / 180 * Math.PI)} ${(r2 + 1) * Math.sin((-90 + 270 * num / 100) / 180 * Math.PI)}
         A ${r2 + 1} ${r2 + 1} 0 ${d2} 0 0 -${r2 + 1}Z`
      var path3 = draw.path(p3).attr({ fill: fill2, 'stroke-width': 1 })

      // ----------------
      var p2 = `M -${r1 - 1} 0 A ${r1 - 1} ${r1 - 1} 0 0 1 0 -${r1 - 1} L 0 -${r2 + 1}
        A ${r2 + 1} ${r2 + 1} 0 0 0 -${r2 + 1} 0Z`
      const id = `path2_${parseInt(Math.random() * 100000)}`
      var path2 = draw.path(p2).attr({ fill: '#fff', id: id })
      group_g.add(path)
      group_g.add(path2)
      group_g.add(path3)
      var text = draw.plain().attr('dy', 14).css({ 'font-size': '14px', 'text-anchor': 'middle', fill: 'rgb(127, 132, 136)' })
      var textPath = text.path()
      textPath.attr({ 'href': '#' + id, startOffset: '25%' })
      textPath.plain(value)
      group_g.add(text)
      const deg = -90
      const lines = []
      for (let i = 1; i <= 9; i++) {
        const line = draw.line((r1 - 1) * Math.cos((deg + 27 * i) / 180 * Math.PI), (r1 - 1) * Math.sin((deg + 27 * i) / 180 * Math.PI)
          , (r2 + 1) * Math.cos((deg + 27 * i) / 180 * Math.PI), (r2 + 1) * Math.sin((deg + 27 * i) / 180 * Math.PI))
          .attr({ stroke: '#fff', 'stroke-width': 1 })
        lines.push(line)
      }
      for (let i = 0; i < lines.length; i++) {
        group_g.add(lines[i])
      }

      group.transform({ translateX: tX, translateY: tY, scale: 0.9 })
    },
    drawSvg2 (draw, sizeX, sizeY, r1, r2, tX, tY, fill, imageUrl) {
      var group = draw.group()
      var wCircle = draw.circle(2 * r1).attr({ cx: sizeX / 2, cy: sizeY / 2, fill: '#fff', stroke: fill, 'stroke-width': 1 })
      var nCircle = draw.circle(2 * r2).attr({ cx: sizeX / 2, cy: sizeY / 2, fill: '#fff', stroke: fill, 'stroke-width': 1 })
      var image = draw.image(imageUrl).attr({ x: sizeX / 2 - 25, y: sizeY / 2 - 25, width: 50, height: 50 })
      var group_g = draw.group()
      group_g.transform({ translateX: sizeX / 2, translateY: sizeY / 2 })
      group.add(wCircle)
      group.add(nCircle)
      group.add(image)
      group.add(group_g)
      group.transform({ translateX: tX, translateY: tY, scale: 0.9 })
    },
    drawSvg3 (draw, sizeX, sizeY, r1, r2, tX, tY, fill, fill2, imageUrl, value, num) {
      var group = draw.group()
      var wCircle = draw.circle(2 * r1).attr({ cx: sizeX / 2, cy: sizeY / 2, fill: '#fff', stroke: fill, 'stroke-width': 1 })
      var nCircle = draw.circle(2 * r2).attr({ cx: sizeX / 2, cy: sizeY / 2, fill: '#fff', stroke: fill, 'stroke-width': 1 })
      var image = draw.image(imageUrl).attr({ x: sizeX / 2 - 25, y: sizeY / 2 - 25, width: 50, height: 50 })
      var group_g = draw.group()
      group_g.transform({ translateX: sizeX / 2, translateY: sizeY / 2 })
      group.add(wCircle)
      group.add(nCircle)
      group.add(image)
      group.add(group_g)
      // ----------------
      var p2 = `M -${r1 - 1} 0 A ${r1 - 1} ${r1 - 1} 0 0 1 0 -${r1 - 1} L 0 -${r2 + 1}
        A ${r2 + 1} ${r2 + 1} 0 0 0 -${r2 + 1} 0Z`
      const id = `path2_${parseInt(Math.random() * 100000)}`
      var path2 = draw.path(p2).attr({ fill: '#fff', id: id })
      group_g.add(path2)
      var text = draw.plain().attr('dy', 14).css({ 'font-size': '14px', 'text-anchor': 'middle', fill: 'rgb(127, 132, 136)' })
      var textPath = text.path()
      textPath.attr({ 'href': '#' + id, startOffset: '25%' })
      textPath.plain(value)
      group_g.add(text)
      group.transform({ translateX: tX, translateY: tY, scale: 0.9 })
    },
    drawCircle (draw, x1, y1, x2, y2, color, direction) {
      for (let i = 0; i < 4; i++) {
        const timeline = new Timeline()
        const runner = new Runner(2000)
        runner.loop(100, false, 0)
        runner.ease('-')
        let circle
        if (direction) {
          circle = draw.circle(15).attr({ cx: x1 / 2 + x2, cy: y1 / 2 + y2, fill: color })
          runner.attr({ cx: x1 / 2, cy: y1 / 2 })
        } else {
          circle = draw.circle(15).attr({ cx: x1 / 2, cy: y1 / 2, fill: color })
          runner.attr({ cx: x1 / 2 + x2, cy: y1 / 2 + y2 })
        }
        runner.element(circle)
        timeline.schedule(runner, i * 400)
        timeline.play()
      }
    }
  }
}
</script>
<style lang='stylus' scoped>
.svg
  width 100%
  height 100%
</style>
